export const formItemLayout = {
  labelCol: {
    span: 24
  },
  wrapperCol: {
    span: 24
  }
};
export const tailFormItemLayout = {
  wrapperCol: {
    span: 24,
    offset: 0
  }
};
export const bottomFormItemLayout = {
  wrapperCol: {
    span: 16,
    offset: 0
  }
};
